export default "__VITE_ASSET__9c33ed41__"